import * as styles from "@/pages/InvoiceDetailPage.styles";
import { Check, Copy } from "lucide-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

interface CopyableValueProps {
  value: string;
  className?: string;
}

const CopyableValue = ({ value, className }: CopyableValueProps) => {
  const { t } = useTranslation("invoiceDetail");
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    [],
  );

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      console.error("Failed to copy to clipboard:", error);
    }
  }, [value]);

  return (
    <span className={styles.copyableWrap}>
      <span className={className}>{value}</span>
      <button type="button" onClick={handleCopy} className={styles.copyButton} title={t("copy")} aria-label={t("copy")}>
        {copied ? <Check className={styles.copyIcon} /> : <Copy className={styles.copyIcon} />}
      </button>
      {copied && <span className={styles.copiedHint}>{t("copied")}</span>}
    </span>
  );
};

export { CopyableValue, type CopyableValueProps };
